module.exports = {
  carMenuInterior: () => {
    return {
      "IONIQ 5 EV-POWER": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "TUCSON HEV LIMITED": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "PALISADE SPORT": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "STARIA LUJO": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "VENUE LIMITED AT": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "HB20 ADVANCE": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
            slug: "ajustes-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "HB20S ADVANCE": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },


      "CRETA PREMIUM": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },
      "KONA HEV LIMITED": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "SANTA FE HEV LIMITED 4x4": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "GRAND i10 AT PREMIUM": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

      "PALISADE HEV 4x4": {
        "menu": [
          {
            icon:require("./../UI/mobile/carStudio/Icon_Caracteristicas.svg"),
            slug: "caracteristicas"
          },
          // {
          //   icon:require("./../UI/mobile/carStudio/Icon_Ajustes.svg"),
          //   slug: "ajustes-interior"
          // },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Light.svg"),
            slug: "luces-interior"
          },
          {
            icon:require("./../UI/mobile/carStudio/Icon_Info.svg"),
            slug: "info"
          }
        ]
      },

    }
  }
}